export const HOST_FOR_STORAGE = '/api/'
export const API_LIST_OF_ROLES = '/api/constants/roles'

export const API_LOGIN = '/api/login'
export const API_AGENT_REGISTRATION = '/api/agent/register'
export const API_REGISTRATION = '/api/register'
export const API_GET_USER = '/api/get-user'

export const API_FINANCE = '/api/finance'
export const API_GET_FINANCE_BY_IDS = '/api/finance/get-by-ids'
export const API_GET_MOTIVATION_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS = '/api/finance/get-by-ids/grouped-by-closed-order-and-motivation'
export const API_GET_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS = '/api/finance/get-by-ids/grouped-by-closed-order'
export const API_FINANCE_REQUESTS = '/api/finance/requests'
export const API_FINANCE_SPLITS = '/api/finance/splits'
export const API_FINANCE_VIRTUALS = '/api/finance/virtuals'
export const API_FINANCE_PAYMENTS = '/api/finance/payments'
export const API_POST_FINANCE_SUBSTATUS_CREATE = '/api/finance/substatus/create'
export const API_DELETE_FINANCE_SUBSTATUS_DELETE = '/api/finance/substatus/delete'
export const API_GET_FINANCE_COMPANY_STATISTICS = '/api/finance/company-statistics';
export const API_GET_FINANCE_COMPANY_STATISTICS_SUMMARY = '/api/finance/company-statistics/summary';
export const API_FINANCE_VAT_ZERO_EXPORT = '/api/finance/vat-zero-export';
export const API_FINANCE_VAT_ZERO_EXPORT_CONVERT_XML = '/api/finance/vat-zero-export/convert-xml';
export const API_FINANCE_VAT_ZERO_EXPORT_MERGE_XML = '/api/finance/vat-zero-export/merge-xml';
export const API_FINANCE_VAT_ZERO_EXPORT_DOWNLOAD = '/api/finance/vat-zero-export/download';

export const API_USERS = '/api/users'
export const API_USERS_LISTS = '/api/users/lists'                                               // {list-type} - for-accountants, etc
export const API_USER_AVATARS = '/api/user/avatar'
export const API_USER_ANALYTIC = '/api/users/analytic'
export const API_USER_ANALYTIC_BY_DEPARTMENT = '/api/users/analytic/department'
export const USER_LOGINS = '/api/user-logins'                                                    //array
export const API_POST_USER_DASHBOARD_TASKS = '/api/users/dashboard-tasks'
export const API_POST_USER_DASHBOARD_ORDERS_IN_WORK = '/api/users/dashboard-orders-in-work'
export const API_POST_USER_DASHBOARD_ORDERS_CLOSED = '/api/users/dashboard-orders-closed'
export const API_POST_USER_DASHBOARD_MARGIN_PROFIT = '/api/users/dashboard-margin-profit'

// User Table Settings API
export const API_USER_TABLE_SETTINGS = '/api/user-table-settings'
export const API_USER_TABLE_SETTINGS_SYNC = '/api/user-table-settings/sync-from-local'
export const API_POST_USER_DASHBOARD_MARGIN_PROFIT_COMPANY = '/api/users/dashboard-margin-profit-company'
export const API_POST_USER_DASHBOARD_MARGIN_PROFIT_COMPANY_YEAR = '/api/users/dashboard-margin-profit-company-year'
export const API_POST_USER_ACTION_HISTORY = '/api/users/action-history'
export const API_POST_USER_ACTION_HISTORY_FOR_HEAD = '/api/users/action-history-for-head'

export const API_ORDERS = '/api/orders'
export const API_ORDERS_SERVICE_ACTIVITY_HISTORY = '/api/orders/services/activity-history'       // user_ids - array of user ids; order_service_ids - array of order_service_id ids
export const API_ORDERS_HISTORY = 'api/orders/action-history'
export const API_GET_ORDER_COPY = '/api/orders/copy'                                            // {id}
export const API_ORDERS_SERVICE = '/api/orders/service'                                         // {id}/users - set users on services
export const API_ORDERS_BY_SERVICES = '/api/orders/services'                                    // {id}
export const API_ORDERS_SERVICE_PROPERTY = '/api/orders/service/property'
export const API_GET_ORDERS_SERVICES_PROPERTIES = '/api/orders/{order_id}/services/{id}'        // {order_service_id}

export const API_POST_ORDERS_SERVICES_MASS_SAVE = '/api/orders/services/mass-save'
export const API_GET_ORDERS_SERVICES_V2_LOGISTICS = '/api/orders/services/v2/logistics' 
export const API_POST_ORDERS_SERVICES_UPDATE_V2 = '/api/orders/services/v2'                     // {id}
export const API_GET_SERVICES_BY_ORDERS = '/api/orders/services/by-order'                       // {id}
export const API_POST_SERVICE_PROPERTIES_BY_ORDER_LIST = '/api/orders/services/by-orders-list'  // {orders_list: [1,2,3], uploading_items: [{special_params}, {special_params}]}
export const API_PUT_ORDER_SERVICES = '/api/orders/services'                                    // {id}
export const API_GET_ORDERS_SERVICES_PROPERTIES_LIST = '/api/orders/services/get-properties-list' // example: ?order_service_id=1&reference_service_property_ids=1,2,3,4,5
export const API_GET_ORDERS_BY_IDS = '/api/orders/get-by-ids'
export const API_POST_ORDERS_SUBSTATUS_CREATE = '/api/orders/substatus/create'
export const API_DELETE_ORDERS_SUBSTATUS_DELETE = '/api/orders/substatus/delete'
export const API_ORDER_OUTSOURCE = '/api/orders/outsource'
export const API_ORDER_VALIDATE_STATUS_541 = '/api/orders/validate-status-541'
export const API_ORDER_VALIDATE_STATUS_542 = '/api/orders/validate-status-542'

export const API_POST_ORDER_SERVICES_QUOTATIONS_SAVE = '/api/orders/services/quotations/save'
export const API_POST_ORDER_SERVICES_QUOTATIONS_FIND = '/api/orders/services/quotations/find'
export const API_GET_ORDER_SERVICES_QUOTATIONS = '/api/orders/services/quotations'              // {id}

// API для общих услуг (не логистика)
export const API_POST_ORDER_SERVICES_GENERAL_QUOTATIONS_SAVE = '/api/orders/services/general-quotations/save'
export const API_POST_ORDER_SERVICES_GENERAL_QUOTATIONS_FIND = '/api/orders/services/general-quotations/find'
export const API_GET_ORDER_SERVICES_GENERAL_QUOTATIONS = '/api/orders/services/general-quotations'              // {id}

// API для ответов на котировки
export const API_ORDER_SERVICE_QUOTATION_ANSWERS = '/api/orders/services/quotations/answers'
export const API_ORDER_SERVICE_QUOTATION_ANSWERS_SEND = '/api/orders/services/quotations/answers'
export const API_ORDER_SERVICE_QUOTATION_ANSWERS_SELECT = '/api/orders/services/quotations/answers'
export const API_ORDER_SERVICE_QUOTATION_ANSWERS_CLIENT_RATE = '/api/orders/services/quotations/answers'

// API для ответов на котировки общих услуг
export const API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS = '/api/orders/services/general-quotations/answers'
export const API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_SEND = '/api/orders/services/general-quotations/answers'
export const API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_SELECT = '/api/orders/services/general-quotations/answers'
export const API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_CLIENT_RATE = '/api/orders/services/general-quotations/answers'

export const API_COMPETITORS_SUPPLIES = '/api/competitors/supplies'
export const API_COMPETITORS = '/api/competitors'

export const API_BDR = '/api/bdr' 
export const API_BDR_RECALCULATE_FILES = '/api/bdr/recalculate-files'
export const API_BDR_FIND_FILES = '/api/bdr/find-files'
export const API_BDR_1C_DICTIONARY = '/api/bdr/dictionary-1c'
export const API_BDR_SAVE_ONE_ELEMENT = '/api/bdr/save-one-element'
export const API_BDR_IMPORT = '/api/bdr/import'
export const API_BDR_DICTIONARY = '/api/bdr/dictionary'    
export const API_BDR_HISTORY_IMPORT = '/api/bdr-history-import'

export const API_BDR2026 = '/api/bdr2026'
export const API_BDR2026_FIND_FILES = '/api/bdr2026/find-files'
export const API_BDR2026_IMPORT = '/api/bdr2026/import'
export const API_BDR2026_SEARCH_PROPERTY_VARIANTS = '/api/bdr2026/search-property-variants'
export const API_BDR2026_RECALCULATE_FILES = '/api/bdr2026/recalculate-files'
export const API_BDR2026_SAVE_ONE_ELEMENT = '/api/bdr2026/save-one-element'
export const API_BDR2026_HISTORY_IMPORT = '/api/bdr2026/history-import'
export const API_BDR2026_RECALC_ONE_ROW = '/api/bdr2026/recalc-one-row'
export const API_BDR2026_DICTIONARY = '/api/bdr2026/dictionary'
export const API_BDR2026_1C_DICTIONARY = '/api/bdr2026/dictionary-1c'

export const API_AIRPORTS = '/api/airports'                                                     // справочник аэропортов (для логистики)
export const API_REFERENCE = '/api/references'                                                  // can take reference_id as reference_parent_id
export const API_REFERENCE_PROPERTIES = '/api/references/properties'                            // can take reference_id

export const API_DADATA_COMPANY = '/api/dadata/company'
export const API_DADATA_NAME = '/api/dadata/name'
export const API_DADATA_EMAIL = '/api/dadata/email'
export const API_DADATA_BANK = '/api/dadata/bank'
export const API_COMPANY = '/api/companies'
export const API_COMPANY_SEARCH = '/api/companies/search'                                       // s - searchline
export const API_PAYMENTS_DETAIL = '/api/companies/payment/details'
export const API_COMPANY_DOC_GENERATOR = '/api/companies/document-generator'

export const API_EMPLOYEES = '/api/employees'

export const API_GET_NOTIFICATIONS_ALL = '/api/notifications'
export const API_GET_NOTIFICATIONS_UNREAD = '/api/notifications/unread'
export const API_POST_NOTIFICATIONS_READ = '/api/notifications/read'                            // /{$id}
export const API_POST_NOTIFICATIONS_ORDERS_READ = '/api/notifications/read-all-orders'          // can take "place" parameter
export const API_POST_NOTIFICATIONS_READ_BY_SERVICE_REFERENCE_ID = '/api/notifications/read-by-service'      // /{$id}
export const API_POST_FINANCE_REQUEST_NOTIFICATIONS_READ_BY_CREATOR_USER_ID = '/api/notifications/read-finance-requests-by-creator-user-id'      // /{$id}
export const API_POST_NOTIFICATIONS_READ_ALL = '/api/notifications/read-all'
export const API_DELETE_NOTIFICATION = '/api/notifications/delete'                              // /{$id}
export const API_POST_NOTIFICATION_ALL = '/api/notifications/delete-all'

export const API_LOG_HISTORY = '/api/logs'

export const API_DOCUMENTS = '/api/documents'
export const API_GET_DOCUMENTS_BY_IDS = '/api/documents/get-by-ids'
export const API_MULTI_DELETE_DOCUMENTS = '/api/documents/delete'

export const API_COLD_CLIENTS = '/api/cold-clients'

export const API_AGENT_TEAM_REQUESTS = '/api/agent-team-requests'

export const API_IMPORT = '/api/import'

export const API_STATISTIC = '/api/finances/general-reports'
export const API_TOP_COMPANIES_EXCEL_ENRICHMENT = '/api/finances/general-reports/top-companies-excel'
export const API_ANALYTICS_NEW_LEADS = '/api/analytics/new-leads'
export const API_ANALYTICS_NEW_BIDS = '/api/analytics/new-bids'
export const API_ANALYTICS_BIDS_IN_WORK_PERIOD = '/api/analytics/bids-in-work-period'
export const API_ANALYTICS_BIDS_IN_WORK = '/api/analytics/bids-in-work'
export const API_ANALYTICS_BIDS_IN_CANCEL = '/api/analytics/bids-in-cancel'
export const API_ANALYTICS_NEW_SUPPLIES = '/api/analytics/new-supplies'
export const API_ANALYTICS_SUPPLIES_IN_WORK = '/api/analytics/supplies-in-work'
export const API_ANALYTICS_SUPPLIES_SUCCESS = '/api/analytics/supplies-success'
export const API_ANALYTICS_SUPPLIES_FINALIZED = '/api/analytics/supplies-finalized'
export const API_ANALYTICS_SUPPLIES_IN_CANCEL = '/api/analytics/supplies-in-cancel'
export const API_ANALYTICS_DEBT_OF_BUYERS_7_DAYS = '/api/analytics/debt-of-buyers-7-days'
export const API_POST_GENERATE_EXCEL = '/api/generate/excel'

export const API_DOWNLOAD_DOCUMENTS = '/api/download/documents'


export const API_QUICK_TASKS = '/api/quick-tasks'

export const API_TASKS = '/api/tasks'
export const API_UPDATE_TASKS = '/api/tasks/update'
export const API_USER_TASKS = '/api/user/tasks'

export const API_POST_KPI_B2B_RESULT = '/api/kpi-b2b-result'  // Save results
export const API_POST_MOTIVATION_ORDER_SCORING = '/api/motivation/order-scoring'
export const API_GET_MOTIVATION_ORDER_SCORING = '/api/motivation/order-scoring'     // {id}

export const API_ORDER_SCORES = '/api/order-scores'

export const API_GET_ALL_SETTINGS = '/api/motivation/settings'
export const API_GET_MOTIVATION = '/api/motivation'
export const API_POST_MOTIVATION_MASS_SAVE_BY_HEADS = '/api/motivation/mass-save-by-heads'
// export const API_POST_MOTIVATION_CALCULATION = '/api/motivation/calculation'
export const API_POST_MOTIVATION_CALCULATION = '/api/motivation/new-calculation'
export const API_GET_MOTIVATION_LOAD_USER_ORDERS_FOR_CHARTS = '/api/motivation/kpi-b2b-user-orders-results'
export const API_GET_MOTIVATION_LOAD_RESULTS_FOR_CHARTS = '/api/motivation/kpi-b2b-results'
export const API_GET_MOTIVATION_LOAD_RESULTS = '/api/motivation/load-results'
export const API_GET_MOTIVATION_REPORT = '/api/motivation/report'
export const API_POST_MOTIVATION_HAND_RESULTS_BY_USER_ID = '/api/motivation/hand-results'
export const API_POST_FINANCE_MOTIVATION_BY_USER_ID = '/api/motivation/finance-by-user-id'

export const API_GET_PLAN_SALES_SHOW = '/api/plan/sales/show-quarter'
export const API_GET_PLAN_TO_LOGISTIC_SHOW = '/api/plan/ved/show-quarter'
export const API_POST_PLAN_SALES_CALCULATION = '/api/plan/sales/calculation'
export const API_POST_PLAN_TO_LOGISTIC_CALCULATION = '/api/plan/ved/calculation'

export const API_DRIVERS = '/api/drivers'
export const API_TRUCKS = '/api/trucks'
export const API_COMPANY_DADATA_CHECK = '/api/company-dadata-check'
export const API_COMPANY_INSURANCE = '/api/company-insurance'
export const API_AGENT_COMPANY = '/api/agent-companies'
export const API_AGENT_DAILY_STATISTICS = '/api/agent-daily-statistics'
export const API_AGENT_DAILY_STATISTICS_MONTHLY_STATS = '/api/agent-daily-statistics/monthly-stats'
export const API_AGENT_DAILY_STATISTICS_UPDATE = '/api/agent-daily-statistics/update'
export const API_AGENT_DAILY_STATISTICS_AGGREGATED = '/api/agent-daily-statistics/aggregated'
export const API_AGENT_DAILY_STATISTICS_ALL_TIME = '/api/agent-daily-statistics/all-time'
export const API_AGENT_SETTLEMENTS = '/api/agent-settlements'
export const API_AGENT_WITHDRAWAL_REQUESTS = '/api/agent-withdrawal-requests'
export const API_NEWS = '/api/news'
export const API_AGENT_DASHBOARD_SUMMARY = '/api/agent/dashboard/summary'

export const API_POST_WORD_DOC_BY_TEMPLATE = '/api/generate/word-doc-by-template'
export const API_POST_WORD_DOC_EXPORT_PARTNERS = '/api/generate/word-doc-for-partners'

export const API_COMMENTS = '/api/comments'
export const API_TICKETS = 'https://b2c.tanais.tech/api/v1/b2b/taskbook/index.php'

export const API_ALL_CLIENTS_PORTFOLIO = '/api/companies/clients_portfolio'
export const API_CLIENTS_PORTFOLIO_SUMMARY = '/api/companies/clients_portfolio/summary'
export const API_CLIENTS_PORTFOLIO_MANAGERS = '/api/companies/clients_portfolio/managers'
export const API_CLIENTS_PORTFOLIO_FINANCE_EXPORT = '/api/companies/clients_portfolio/finance-export'
export const API_TO_SALES_CLIENTS_PORTFOLIO = '/api/companies/clients_portfolio/to_sales'

export const API_USER_CALL = '/api/user-call'
export const API_MAKE_A_CALL = '/api/user-call/make-a-call'

export const API_ORDERS_ACTION_HISTORY = '/api/orders/action-history'

export const API_ORDERS_KANBAN = '/api/orders/kanban'

export const API_SALES_ANALYTICS_REQUESTS = '/api/sales-analytic/requests'
export const API_SALES_ANALYTICS_FEEDBACK = '/api/sales-analytic/feedback'
export const API_SALES_ANALYTICS_COUNTRIES = '/api/sales-analytic/countries'
export const API_SALES_ANALYTICS_MANAGERS = '/api/sales-analytic/managers'

export const API_ORDERS_ANALYTICS_LEADS = '/api/order-analytic/leads'
export const API_ORDERS_ANALYTICS_ORDERS_VS_SUPPLIES = '/api/order-analytic/orders-vs-supplies'

export const API_TRANSPORT_TYPES = '/api/transport-types'
export const API_TRANSPORT_TYPES_BY_CATEGORY = '/api/transport-types/by-category'
export const API_COMPANY_TRANSPORT_TYPES = '/api/companies/transport-types'

export const API_ORDER_SUPPLIER = '/api/order-supplier-requests'

export const API_EMAIL_TRACKING = '/api/email-tracking'
export const API_CHECK_SMTP_AVAILABILITY = '/api/users/smtp-settings/check-availability'

export const API_COMPANY_FINANCE_SERVICES = '/api/companies/finance-services';
export const API_COMPANY_FINANCE_TEMPLATES = '/api/companies/finance-templates';

export const API_FINANCE_ANALYTICS_INCOME_EXPANSES = '/api/finance-analytic/income-expenses'

// Константы для ответов на котировки поставщиков
export const API_ORDER_SERVICES_QUOTATION_ANSWERS = '/api/orders/services/quotation-answers'   // {id}  // {id}/send  // {id}/select

// Константы для рейтинга агентов
export const API_AGENT_RATING = '/api/agent-rating'
export const API_AGENT_RATING_UPDATE_FAKE_AGENTS = '/api/agent-rating/update-fake-agents'
export const API_AGENT_RATING_QUARTERLY_RESET = '/api/agent-rating/quarterly-reset'

// Константы для регионов
export const API_REGIONS = '/api/regions'

export const API_AGENT_CORP_MAIL = '/api/agent-corp-mail'

export const API_MEMORIES = '/api/memories'
export const API_LESSONS = '/api/lessons'

// API для калькуляторов
export const API_CALCULATOR_SETTINGS = '/api/calculator/settings'
export const API_CALCULATOR_SETTINGS_AVIATION = '/api/calculator/settings/aviation'
export const API_CALCULATOR_SETTINGS_RAILWAY = '/api/calculator/settings/railway'
export const API_CALCULATOR_SETTINGS_AUTO = '/api/calculator/settings/auto'
export const API_CALCULATOR_SETTINGS_SEA = '/api/calculator/settings/sea'

// API для отчетов по таможенному оформлению
export const API_TO_ACTIVITY_REPORT_DATA = '/api/reports/to-activity/data'
export const API_TO_ACTIVITY_REPORT_STATUSES = '/api/reports/to-activity/statuses'
export const API_TO_ACTIVITY_REPORT_USERS = '/api/reports/to-activity/users'

// API для отчетов по ставкам заявок
export const API_QUOTATION_RATES_DATA = '/api/reports/quotation-rates/data'
export const API_QUOTATION_RATES_USERS = '/api/reports/quotation-rates/users'
export const API_QUOTATION_RATES_DEPARTMENTS = '/api/reports/quotation-rates/departments'
export const API_QUOTATION_RATES_FILTER_DATA = '/api/reports/quotation-rates/filter-data'
export const API_QUOTATION_RATES_UPDATE_RATE = '/api/orders/services/quotation-answers'

// API для отчетов по эффективности отделов
export const API_DEPARTMENT_EFFICIENCY_DATA = '/api/reports/department-efficiency/data'
export const API_DEPARTMENT_EFFICIENCY_FILTER_DATA = '/api/reports/department-efficiency/filter-data'

// API для отчета «Финансовые показатели заказов»
export const API_ORDER_FINANCE_REPORT_DATA = '/api/reports/order-finance/data'
export const API_ORDER_FINANCE_REPORT_FILTER_DATA = '/api/reports/order-finance/filter-data'

// API для мотивации 2025
export const API_MOTIVATION2025_LOGISTICS = '/api/motivation2025/logistics'
export const API_MOTIVATION2025_TO = '/api/motivation2025/to'
export const API_MOTIVATION2025_TO_PERSONAL = '/api/motivation2025/to/personal'
export const API_MOTIVATION2025_SALES = '/api/motivation2025/sales'
export const API_MOTIVATION2025_SALES_DETAILED_CALCULATIONS = '/api/motivation2025/sales/detailed-calculations'
export const API_MOTIVATION2025_FIX_QUARTER = '/api/motivation2025/fix-quarter'
// Логистика
export const API_MOTIVATION2025_CHARTS_EFFICIENCY = '/api/motivation2025/charts/efficiency'
export const API_MOTIVATION2025_CHARTS_MARGINALITY = '/api/motivation2025/charts/marginality'
export const API_MOTIVATION2025_DETAILED_CALCULATIONS = '/api/motivation2025/detailed-calculations'

// ТО
export const API_MOTIVATION2025_CHARTS_TO_MARGINALITY = '/api/motivation2025/charts/to-marginality'
export const API_MOTIVATION2025_CHARTS_DECLARATIONS = '/api/motivation2025/charts/declarations'
export const API_MOTIVATION2025_CHARTS_SALES_MARGINALITY = '/api/motivation2025/charts/sales-marginality'

export const API_DEPARTMENTS = '/api/departments'
